import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'loading',
  initialState: {
    isLoading: false,
    activeRequests: 0,
  },
  reducers: {
    startRequest: (state) => {
      state.activeRequests += 1;
      state.isLoading = true;
    },
    finishRequest: (state) => {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
      state.isLoading = state.activeRequests > 0;
    },
  },
});

export { actions as loadingActions };
export { reducer as loadingReducer };
